<template>
  <div id="excel-expedientes">
    <custom-button
      label="Estatus Expedientes"
      iconText="fa-file-excel"
      tipo="agregar"
      class="mr-2"
      :loading="estaCargando"
      @click="generarExcelExpedientes">
    </custom-button>
  </div>
</template>

<script>
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import CustomButton from '@/components/buttons/Button.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 2;
// const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 1;

export default {
  name: 'ExcelExpedientes',
  mixins: [mixGenerarExceles],
  props: {
    listaContratos: {
      type: Array,
      required: true,
    },
    expedientes: {
      type: Array,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      estaCargando: false,
      nombreDocumento: 'ESTATUS DE CONTRATOS CON EXPEDIENTE',
      configuracionExcel: {},
      contrato: {
        numero: '',
      },
      filaTitulos: 2,
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
        },
      },
      // Datos de los encabezados que apareceran en el excel.
      headersColumnas: [
        {
          value: 'Fecha de Contrato', nombreColumna: 'fechaContrato', orden: 1,
        },
        {
          value: 'Contrato', nombreColumna: 'numeroContrato', orden: 2,
        },
        {
          value: 'Objeto', nombreColumna: 'meta', orden: 3,
        },
        {
          value: 'Contratista', nombreColumna: 'contratista', orden: 4,
        },
        {
          value: 'Residente', nombreColumna: 'residente', orden: 5,
        },
        {
          value: 'Documentos', nombreColumna: 'documentosTotales', orden: 6,
        },
        {
          value: 'No Aplican', nombreColumna: 'documentosNoAplican', orden: 7,
        },
        {
          value: 'Aplican', nombreColumna: 'documentosAplican', orden: 8,
        },
        {
          value: 'Integrados', nombreColumna: 'documentosIntegrados', orden: 9,
        },
        {
          value: 'Faltantes', nombreColumna: 'documentosFaltantes', orden: 10,
        },
      ],
    };
  },
  methods: {
    async generarExcelExpedientes() {
      if (this.listaContratos.length > 0) {
        const data = this.crearExcelExpedientes;
        await this.mixGenerarExcel(data);
      }
    },
    getResponsable(contrato) {
      const responsable = contrato.responsables
        .find((contratoResponsable) => contratoResponsable.principal);
      if (!responsable) return '';
      return responsable.funcionario.nombre;
    },
    getDocumentosTotales(idContrato) {
      const documentosTotales = this.expedientes
        .filter((documento) => documento.idContrato === idContrato).length;
      return documentosTotales;
    },
    getDocumentosNoAplican(idContrato) {
      let documentosNoAplican = 0;
      this.getExpedienteContrato(idContrato).forEach((documento) => {
        if (!documento.aplica) documentosNoAplican += 1;
      });
      return documentosNoAplican;
    },
    getDocumentosAplican(idContrato) {
      let documentosAplican = 0;
      this.getExpedienteContrato(idContrato).forEach((documento) => {
        if (documento.aplica) documentosAplican += 1;
      });
      return documentosAplican;
    },
    getDocumentosFaltantes(idContrato) {
      let documentosFaltantes = 0;
      this.getExpedienteContrato(idContrato).forEach((documento) => {
        if (!documento.existe && documento.aplica) documentosFaltantes += 1;
      });
      return documentosFaltantes;
    },
    getDocumentosIntegrados(idContrato) {
      let documentosIntegrados = 0;
      this.getExpedienteContrato(idContrato).forEach((documento) => {
        if (documento.publicKey) documentosIntegrados += 1;
      });
      return documentosIntegrados;
    },
    getExpedienteContrato(idContrato) {
      const expediente = this.expedientes
        .filter((documento) => documento.idContrato === idContrato);
      return expediente;
    },
  },
  computed: {
    getHeaders() {
      const headers = this.headersColumnas
        .map((header) => header.value)
        .sort((a, b) => a.orden - b.orden);
      return headers;
    },

    getExpedientesParaExcel() {
      return this.listaContratos.map((contrato) => ({
        fechaContrato: contrato.fecha,
        numeroContrato: contrato.numero,
        meta: contrato.meta,
        contratista: contrato.contratista.nombreRazonSocial,
        residente: this.getResponsable(contrato),
        documentosTotales: this.getDocumentosTotales(contrato.id),
        documentosNoAplican: this.getDocumentosNoAplican(contrato.id),
        documentosAplican: this.getDocumentosAplican(contrato.id),
        documentosIntegrados: this.getDocumentosIntegrados(contrato.id),
        documentosFaltantes: this.getDocumentosFaltantes(contrato.id),
      }));
    },

    getColumnas() {
      const columnas = this.headersColumnas
        .map((columna) => columna.nombreColumna)
        .sort((a, b) => a.orden - b.orden);
      return columnas;
    },

    crearDatosDocumento() {
      return [
        {
          value: 'ESTATUS DE EXPEDIENTES DE CONTRATOS',
          row: 1,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'left',
              vertical: 'center',
            },
          },
          combinar: {
            row: 1,
            col: 10,
          },
        },
      ];
    },

    crearExcelExpedientes() {
      const expedientesExcel = this.getExpedientesParaExcel;
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.getHeaders;
      // Se agregan totales para cantidad e importe a nombres de columnas.
      const nombreDeColumnas = [...this.getColumnas];

      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            // logos: [...this.logoDocumento],
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: [...expedientesExcel],
          },
        },
      };
      return data;
    },
  },

};
</script>

<style>

</style>
